import { yupResolver } from '@hookform/resolvers/yup';
import { IonInput, IonList } from '@ionic/react';
import { handleServerHookForm } from '@napa/react-core';
import { GrapeButton } from 'napa-react-core';
import HookInput from 'components/baseElements/formControls/HookInput';
import { Box } from 'components/baseElements/grid';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

interface ResetPasswordFormWebProperties {
  submitAction: (data: any) => any;
  changePasswordIsSaving?: boolean;
  serverValidation?: any;
  validationSchema?: any;
  showExistingPassword: boolean;
}

export default function ResetPasswordFormWeb(props: ResetPasswordFormWebProperties): JSX.Element {
  const { submitAction, serverValidation, validationSchema, showExistingPassword } = props;

  const form = useForm({
    defaultValues: {
      currentPassword: '',
      newPassword: '',
      passwordConfirm: '',
    },
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    handleServerHookForm(serverValidation, form.setError);
  }, [serverValidation, form.setError]);

  return (
    <Box maxWidth={600} mx="auto" width={1}>
      <form onSubmit={form.handleSubmit(submitAction)} noValidate>
        <IonList lines="full">
          {showExistingPassword ? (
            <HookInput
              form={form}
              isRequired
              labelText="changePasswordForm.currentPasswordLabel"
              name="currentPassword"
            >
              <IonInput clearOnEdit={false} type="password" />
            </HookInput>
          ) : undefined}
          <HookInput
            assistiveText="changePasswordForm.passwordAssistiveText"
            form={form}
            isRequired
            labelText="changePasswordForm.newPasswordLabel"
            name="newPassword"
          >
            <IonInput clearOnEdit={false} type="password" />
          </HookInput>
          <HookInput
            form={form}
            isRequired
            labelText="changePasswordForm.passwordConfirmLabel"
            name="passwordConfirm"
          >
            <IonInput clearOnEdit={false} type="password" />
          </HookInput>
        </IonList>
        <GrapeButton expand="block" type="submit">
          <FormattedMessage id="changePasswordForm.saveButtonLabel" />
        </GrapeButton>
      </form>
    </Box>
  );
}
